<template>
  <span class="site-logo">
    <span v-html="logo" />
  </span>
</template>

<script>
import logo from "~/assets/nea-dummy-logo.svg?raw";

export default {
  name: "SiteLogo",
  data: () => ( {
    logo,
  } ),
};
</script>

<style lang="scss" scoped>
.site-logo {
  display: inline-flex;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 10px;

  @media ( max-width: 768px ) {
      padding-bottom: 0 !important;
    }

  :deep( svg ) {
    height: 60px;
    width: auto;

    @media ( max-width: 768px ) {
      height: 50px;
      padding: 0 !important;
      margin: 0 !important;
    }
  }
}

.dark-mode .site-logo :deep( svg ) {
  path:not( .st0 ) {
    stroke: #fff;
    fill: #fff;
  }
}
</style>
